import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { formatPercentage } from '../../utils/format';
var TypicaHandlingRateExplanation = function (_a) {
    var typicaHandlingRates = _a.typicaHandlingRates, isTypicaStockOrder = _a.isTypicaStockOrder;
    var t = useTranslation().t;
    var explanation = React.useMemo(function () {
        if (isTypicaStockOrder) {
            return t('pages.roasterOrder.typicaHandlingFeeExplanationByWeight', {
                lessThan300Kg: formatPercentage('35.0'),
                moreThan300Kg: formatPercentage('25.0'),
                moreThan600Kg: formatPercentage('20.0'),
                moreThan3000Kg: formatPercentage('15.0'),
            });
        }
        if (Object.keys(typicaHandlingRates).includes('less_than_5_bags')) {
            var rate_1 = typicaHandlingRates;
            return t('pages.roasterOrder.typicaHandlingFeeExplanationByBagCount', {
                lessThan5Bags: formatPercentage(rate_1['less_than_5_bags']),
                moreThan5Bags: formatPercentage(rate_1['more_than_5_bags']),
                moreThan10Bags: formatPercentage(rate_1['more_than_10_bags']),
                moreThan50Bags: formatPercentage(rate_1['more_than_50_bags']),
            });
        }
        var rate = typicaHandlingRates;
        return t('pages.roasterOrder.typicaHandlingFeeExplanationByWeight', {
            lessThan300Kg: formatPercentage(rate['less_than_300kg']),
            moreThan300Kg: formatPercentage(rate['more_than_300kg']),
            moreThan600Kg: formatPercentage(rate['more_than_600kg']),
            moreThan3000Kg: formatPercentage(rate['more_than_3000kg']),
        });
    }, [t, isTypicaStockOrder, typicaHandlingRates]);
    return React.createElement(Typography, { variant: "caption" }, explanation);
};
export default TypicaHandlingRateExplanation;
